/* eslint-disable react/display-name */
/* eslint-disable camelcase */
/* eslint-disable comma-dangle */

import React from 'react';
import dynamic from 'next/dynamic';
import Highlight from 'react-scale/components/ui/highlight';
import ExampleLoading from '../ExampleLoading';

const TaskResponsePointAnnotation = dynamic(
  () => import('../tasks/TaskResponseImagePointAnnotation'),
  {
    loading: () => <ExampleLoading />,
    ssr: false
  }
);

export const realResponse = {
  annotations: [
    {
      label: 'facial point',
      left: 3114.57080078125,
      top: 1151.4576416015625,
      geometry: 'point'
    },
    {
      label: 'facial point',
      left: 2912.87353515625,
      top: 1145.6033935546875,
      geometry: 'point'
    },
    {
      label: 'facial point',
      left: 3356.28564453125,
      top: 1125.7432861328125,
      geometry: 'point'
    },
    {
      label: 'facial point',
      left: 3575.65673828125,
      top: 1066.876953125,
      geometry: 'point'
    },
    {
      label: 'facial point',
      left: 3292.85693359375,
      top: 1037.4573974609375,
      geometry: 'point'
    },
    {
      label: 'facial point',
      left: 3651.01904296875,
      top: 965.9454956054688,
      geometry: 'point'
    },
    {
      label: 'facial point',
      left: 3129.427978515625,
      top: 1054.600341796875,
      geometry: 'point'
    },
    {
      label: 'facial point',
      left: 2817.3251953125,
      top: 1037.9432373046875,
      geometry: 'point'
    },
    {
      label: 'facial point',
      left: 3264.85693359375,
      top: 1408.6009521484375,
      geometry: 'point'
    },
    {
      label: 'facial point',
      left: 3088.28515625,
      top: 1486.6011962890625,
      geometry: 'point'
    },
    {
      label: 'facial point',
      left: 3492.857421875,
      top: 1450.60107421875,
      geometry: 'point'
    },
    {
      label: 'facial point',
      left: 3281.42822265625,
      top: 1530.02978515625,
      geometry: 'point'
    },
    {
      label: 'facial point',
      left: 3290.5712890625,
      top: 1584.315673828125,
      geometry: 'point'
    },
    {
      label: 'facial point',
      left: 3318.617919921875,
      top: 1806.7044677734375,
      geometry: 'point'
    },
    {
      label: 'limb joint',
      left: 4476.015625,
      top: 2092.216796875,
      geometry: 'point'
    },
    {
      label: 'limb joint',
      left: 2331.985595703125,
      top: 2192.218017578125,
      geometry: 'point'
    },
    {
      label: 'limb joint',
      left: 4724.01904296875,
      top: 4168.24560546875,
      geometry: 'point'
    },
    {
      label: 'limb joint',
      left: 2139.98291015625,
      top: 4108.24462890625,
      geometry: 'point'
    },
    {
      label: 'limb joint',
      left: 2499.988037109375,
      top: 3656.238525390625,
      geometry: 'point'
    },
    {
      label: 'limb joint',
      left: 4060.009765625,
      top: 3576.2373046875,
      geometry: 'point'
    }
  ]
};

export const instruction = 'Draw a point in each facial point and limb joint.';

export const responseCode = `{
  "response": {
    "annotations": [
      {
        "label": "facial point",
        "left": 3114.57080078125,
        "top": 1151.4576416015625,
      },
      {
        "label": "facial point",
        "left": 2912.87353515625,
        "top": 1145.6033935546875,
      },
      ...
      {
        "label": "limb joint",
        "left": 4476.015625,
        "top": 2092.216796875,
        "geometry": "point",
      },
      ...
    ]
  },
  "task_id": "5795c68afce306120434be64",
  "task": { ... }
}`;

export const code = `client.createAnnotationTask({
  callback_url: 'http://www.example.com/callback',
  instruction: '${instruction}',
  params: {
    with_labels: true,
    objects_to_annotate: ['limb joint', 'facial point'],
    attachment_type: 'image',
    attachment: 'http://i.imgur.com/XOJbalC.jpg'
  },
}, (err, task) => {
    // do something with task
});`;

export const response = (
  <div className="data-collection">
    <Highlight className="javascript" key="highlight-json">
      {responseCode}
    </Highlight>
  </div>
);

export const example = () => (
  <TaskResponsePointAnnotation annotations={[]} imageURL="/static/img/examples/point.jpg" />
);

export const result = (
  <TaskResponsePointAnnotation
    annotations={realResponse.annotations}
    imageURL="/static/img/examples/point.jpg"
  />
);
